import { Tab as Component } from './styled';

export const Tab = Component;
